module.exports = __webpack_public_path__ + "img/icloud.ac48c1d3.png";